// ================= APP =================
export const APP_STRINGS = {
  APP_NAME: "Dekho Sab Kuch Admin",
};

// ================= MENU =================
export const MENU_STRINGS = {
  DASHBOARD: "Dashboard",
  USERS: "Users",
  PROVIDERS: "Providers",
  PAYMENTS: "Payments",
  TICKETS: "Tickets",
  NOTIFICATIONS: "Notifications",
  REPORTS: "Reports",
  LOGOUT: "Logout",
};

// ================= COMMON =================
export const COMMON_STRINGS = {
  SOMETHING_WENT_WRONG: "Something went wrong",
  SERVER_ERROR: "Server error, please try again",
  NETWORK_ERROR: "Network error",

  UNAUTHORIZED: "Session expired, please login again",
  FORBIDDEN: "You are not allowed to perform this action",
  NOT_FOUND: "Resource not found",

  NO_DATA_FOUND: "No data found",
  LOADING: "Please wait...",
  BTN_CONFIRM: "Confirm",
  BTN_CANCEL: "Cancel",
};

// ================= AUTH =================
export const AUTH_STRINGS = {
  LOGIN_TITLE: "Admin Login",
  SUBTITLE: "Login to continue",

  PHONE_PLACEHOLDER: "Enter mobile number",
  OTP_PLACEHOLDER: "Enter OTP",

  SEND_OTP: "Send OTP",
  VERIFY_OTP: "Verify OTP",

  PHONE_REQUIRED: "Phone number is required",
  ENTER_PHONE_ERROR: "Enter valid phone number",
  OTP_REQUIRED: "OTP is required",

  INVALID_OTP: "Invalid OTP",
  LOGIN_SUCCESS: "Login successful",
};

// ================= DASHBOARD =================
export const DASHBOARD_STRINGS = {
  TOTAL_USERS: "Total Users",
  TOTAL_PROVIDERS: "Total Providers",
  TOTAL_REVENUE: "Total Revenue",
  PENDING_TICKETS: "Pending Tickets",

  ANALYTICS_OVERVIEW: "Analytics Overview",

  USERS_PROVIDERS: "Users / Providers Overview",
  REVENUE_TICKETS: "Revenue / Tickets Distribution",
};

// ================= USERS =================
export const USER_LIST_STRINGS = {
  TITLE: "Users",
  SEARCH_PLACEHOLDER: "Search users...",

  ACTIVE: "Active",
  BLOCKED: "Blocked",

  BLOCK: "Block",
  UNBLOCK: "Unblock",

  PHONE: "Phone",
  ADDRESS: "Address",

  CONFIRM_BLOCK_TITLE: "Block User",
  CONFIRM_BLOCK_DESC: "Are you sure you want to block this user?",
};

// ================= PROVIDERS =================
export const PROVIDER_STRINGS = {
  TITLE: "Providers",
  SEARCH_PLACEHOLDER: "Search providers...",

  APPROVE: "Approve",
  REJECT: "Reject",
};

// ================= PAYMENTS =================
export const PAYMENT_STRINGS = {
  TITLE: "Payments",
  SEARCH_PLACEHOLDER: "Search payments...",

  COLUMN_ID: "Payment ID",
  COLUMN_USER: "User",
  COLUMN_AMOUNT: "Amount",
  COLUMN_DATE: "Date",
  COLUMN_STATUS: "Status",
  COLUMN_SERVICE: "Service",
  COLUMN_TIME: "Time",

  GUEST_USER: "Guest User",
};

// ================= REPORTS =================
export const REPORT_STRINGS = {
  TITLE: "Reports",
  SEARCH_PLACEHOLDER: "Search reports...",

  COLUMN_NAME: "Name",
  COLUMN_TYPE: "Type",
  COLUMN_DATE: "Date",
  COLUMN_STATUS: "Status",
  COLUMN_ACTIONS: "Actions",
  COLUMN_MOBILE: "Mobile",
  COLUMN_DESCRIPTION: "Description",

  GUEST_USER: "Guest User",
  NO_DESCRIPTION: "No Description",
};

// ================= NOTIFICATIONS =================
export const NOTIFICATION_STRINGS = {
  TITLE: "Notifications",
  SEARCH_PLACEHOLDER: "Search notifications...",

  STATUS_READ: "Read",
  STATUS_UNREAD: "Unread",

  COLUMN_TITLE: "Message",
  COLUMN_TYPE: "Type",
  COLUMN_DATE: "Date",
  COLUMN_STATUS: "Status",
  COLUMN_ACTIONS: "Actions",
  COLUMN_USER: "User",
  COLUMN_CONTACT: "Contact No",

  MARK_READ: "Mark Read",
  READ: "Read",

  GUEST_USER: "Guest User",
};

// ================= STATUS =================
export const STATUS_CONFIG = {
  ACTIVE: {
    value: "active",
    label: "Active",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  BLOCKED: {
    value: "blocked",
    label: "Blocked",
    bg: "var(--danger-soft)",
    color: "var(--danger)",
  },

  PENDING: {
    value: "pending",
    label: "Pending",
    bg: "var(--warning-soft)",
    color: "var(--warning)",
  },

  IN_PROGRESS: {
    value: "in_progress",
    label: "In Progress",
    bg: "var(--blue-soft)",
    color: "var(--blue)",
  },

  RESOLVED: {
    value: "resolved",
    label: "Resolved",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  READ: {
    value: "read",
    label: "Read",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  UNREAD: {
    value: "unread",
    label: "Unread",
    bg: "var(--warning-soft)",
    color: "var(--warning)",
  },

  APPROVED: {
    value: "approved",
    label: "Approved",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  REJECTED: {
    value: "rejected",
    label: "Rejected",
    bg: "var(--danger-soft)",
    color: "var(--danger)",
  },
   SUCCESS: {
    value: "success",
    label: "Success",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  FAILED: {
    value: "failed",
    label: "Failed",
    bg: "var(--danger-soft)",
    color: "var(--danger)",
  },

};